export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgVGllciA9ICJDdXN0b21lciIgfCAiTVNQIjsK"